<template>
    <div class="NavOrder">
        <div class="show_Alert_style clear" v-if="show_Alert" style="margin-top: -32px;">
            <i class="left"></i>
            <p class="left">Please input the <span>{{show_Alert_Text}}</span> to continue.</p>
        </div>
        <!-- <div class="nav_flight_top">
            <a-radio-group :options="options" @change="onChange" v-model="value" />
        </div> -->
        <ul class="online_bottom clear">
            <li :class="[{'line_border':isnumberShow},'left']">
                <h3>Ticket Number</h3>
                <input type="text" value="" placeholder="Input your ticket number or reservation number" v-model="number"/>
            </li>
            <li :class="[{'line_border':isfirstShow},'left']">
                <h3>First Name</h3>
                <input type="text" value="" placeholder="Input your first name" v-model="firstName"/>
            </li>
            <li :class="[{'line_border':islastShow},'left']">
                <h3>Last Name</h3>
                <input type="text" value="" placeholder="Input your last name" v-model="lastName"/>
            </li>
        </ul>
        <div class="clear btn_cof">
            <!-- <div class="left" v-if="showContactEmail">
                <h3>Contact E-mail while Booking</h3>
                <input type="text" placeholder="Contact E-mail while Booking" />
            </div> -->
            <input :class="[{'mar_top':showContactEmail },'right btn_input si_c_btn_common']" type="button" value="Search" @click="search">
        </div>
    </div>
</template>

<script>
const options = [
    { label: 'SichuanAir Official Channels Order', value: 0 },
    { label: 'Third-party Channels Order', value: 1 },
];
export default {
  components: {
    
  },
  name: 'NavOrder',
  data () {
    return {
        options,
        value:0,
        showContactEmail:false,
        isnumberShow:false,
        isfirstShow:false,
        islastShow:false,
        number:'',
        firstName:'',
        lastName:'',
        show_Alert:false,
        show_Alert_Text:''
    }
  },
  props: {

  },
  watch: {
    number(val){
        if(val){
            this.isnumberShow = false
             this.show_Alert = false
        }
    },
    firstName(val){
        if(val){
            this.isfirstShow = false
             this.show_Alert = false
        }
    },
    lastName(val){
        if(val){
            this.islastShow = false
            this.show_Alert = false
        }
    },
  },
  methods: {
    onChange(e){
        this.value = e.target.value
    },
    search(){
        if(this.number == ''){
            this.isnumberShow = true
            this.show_Alert = true
            this.show_Alert_Text = 'ticket number'
            return
        }
        if(this.firstName == ''){
            this.isfirstShow = true
            this.show_Alert = true
            this.show_Alert_Text = 'first name'
            return
        }
        if(this.lastName == ''){
            this.islastShow = true
            this.show_Alert = true
            this.show_Alert_Text = 'last name'
            return
        }

        var that = this

        this.$Ajax.post(`${this.$BASE_url}Order/GetOrderInfo`, {
            pNumber: this.number,
            fName: this.firstName,
            lName: this.lastName,
            vCode: "1111"
        })
        .then( (response)=> {
            if(response.data.ErrorCode == '0'){
                console.log(response.data.Data)
                that.$Utils.setSession('Order_Information_DATA',response.data.Data)
                that.$router.push('orderinformation')
            }else{
                that.$Modal.error({
                    title: 'SICHUAN AIRLINES',
                    content: response.data.ErrorMessage,
                });
            }
        })
        .catch( (error) =>{
            console.log(error);
        });
        
    }
  },
  filters: {

  },
  computed: {

  },
  created () {
    
  },
  mounted () {
    
  },
  destroyed () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.line_border{
    border-bottom: 4px solid #D8000F;
}
    .NavOrder{
        input[type='text']{
            width: 100%;
        }
        padding-top: 32px;
        .nav_flight_top{
            line-height: 32px;
            margin-bottom: 16px;
            .ant-radio-group{
                &::v-deep .ant-radio-wrapper{
                    margin-right: 53px;
                    span.ant-radio + *{
                        padding-right: 0;
                    }
                }
            }
        }
        .online_bottom{
            margin-bottom: 32px;
            li{
                height: 72px;
                box-shadow:0px 1px 0px 0px rgba(236,238,240,1);
                &:first-child{
                    width: 544px;
                }
                &:nth-child(2),&:nth-child(3){
                    width: 256px;
                }
                &:nth-child(2){
                    margin-left: 32px;
                    margin-right: 32px;
                }
                h3{
                    font-size:12px;
                    color:rgba(128,128,128,1);
                    line-height:14px;
                    margin-top: 16px;
                    margin-bottom: 7px;
                }
                input{
                    font-size:16px;
                    color:rgba(51,51,51,1);
                }
                div{
                    span{
                        font-size:16px;
                        color:rgba(51,51,51,1);
                    }
                    i{
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        margin-top: 3px;
                        background: url(../../../assets/home/icon_date_time_down.png) no-repeat center;
                        background-size: 100% 100%;
                    }
                }
            }
        }
        .btn_cof{
            div{
                height: 72px;
                box-shadow:0px 1px 0px 0px rgba(236,238,240,1);
                width: 544px;
                h3{
                    font-size:12px;
                    color:rgba(128,128,128,1);
                    line-height:14px;
                    margin-top: 16px;
                    margin-bottom: 7px;
                }
                input{
                    font-size:16px;
                    color:rgba(51,51,51,1);
                }
            }
            .mar_top{
                margin-top: 8px;
            }
        }
    }
</style>
